import { collection, doc, setDoc, getDocs, query, limit } from 'firebase/firestore';
import { db } from './config';
import { COLLECTIONS } from './collections';

/**
 * Initialise les collections Firestore nécessaires si elles n'existent pas déjà
 * Cette fonction crée un document temporaire dans chaque collection requise
 * puis le supprime si la collection n'existait pas déjà
 */
export const initializeRequiredCollections = async () => {
  console.log('Initialisation des collections Firestore requises...');
  
  const requiredCollections = [
    COLLECTIONS.INTERVENTIONS,
    'notifications',
    COLLECTIONS.CALENDAR_EVENTS,
  ];
  
  for (const collectionName of requiredCollections) {
    try {
      // Vérifier si la collection existe déjà en essayant de récupérer un document
      const collectionRef = collection(db, collectionName);
      const q = query(collectionRef, limit(1));
      const snapshot = await getDocs(q);
      
      if (snapshot.empty) {
        console.log(`Collection ${collectionName} n'existe pas encore, création en cours...`);
        
        // Créer un document temporaire pour initialiser la collection
        const tempDocRef = doc(collection(db, collectionName), 'temp_init_doc');
        await setDoc(tempDocRef, {
          _tempInit: true,
          createdAt: new Date(),
          description: 'Document temporaire pour initialiser la collection'
        });
        
        console.log(`Collection ${collectionName} initialisée avec succès`);
      } else {
        console.log(`Collection ${collectionName} existe déjà`);
      }
    } catch (error) {
      console.error(`Erreur lors de l'initialisation de la collection ${collectionName}:`, error);
    }
  }
};
